import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './virtual-fence-circle.reducer';

export const VirtualFenceCircleDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const virtualFenceCircleEntity = useAppSelector(state => state.virtualFenceCircle.entity);
  const updating = useAppSelector(state => state.virtualFenceCircle.updating);
  const updateSuccess = useAppSelector(state => state.virtualFenceCircle.updateSuccess);

  const handleClose = () => {
    props.history.push('/virtual-fence-circle' + props.location.search);
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    dispatch(deleteEntity(virtualFenceCircleEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose} centered>
      <ModalHeader toggle={handleClose} data-cy="virtualFenceCircleDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="fleetSenseApp.virtualFenceCircle.delete.question">
        <p>
          <Translate contentKey="fleetSenseApp.virtualFenceCircle.delete.question" interpolate={{ id: virtualFenceCircleEntity.name }}>
            Are you sure you want to delete this VirtualFenceCircle?
          </Translate>
        </p>
        <p className="text-muted small">
          <Translate contentKey="fleetSenseApp.virtualFenceCircle.delete.asyncNotice">
            A exclusão será efetivada após a confirmação do equipamento. O item ficará visível com status pendente até o hardware confirmar.
          </Translate>
        </p>
      </ModalBody>
      <ModalFooter style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
        <Button color="secondary" onClick={handleClose} disabled={updating} style={{ whiteSpace: 'nowrap' }}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button
          id="app-confirm-delete-virtualFenceCircle"
          data-cy="entityConfirmDeleteButton"
          color="danger"
          onClick={confirmDelete}
          disabled={updating}
          style={{ whiteSpace: 'nowrap', minWidth: '170px' }}
        >
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="fleetSenseApp.virtualFenceCircle.delete.requestButton">Solicitar Exclusão</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default VirtualFenceCircleDeleteDialog;
